import { isBefore, parseISO } from "date-fns";
import { months } from "../enums/months";

export function getAbbreviatedDateString(date) {
	if (!date || typeof date !== "object") {
		return null;
	}
	const month = months[date.getMonth()].abbr;
	return `${month} ${date.getDate()}, ${date.getFullYear()}`;
}

export function getLongDateString(date) {
	if (!date || typeof date !== "object") {
		return null;
	}
	const month = months[date.getMonth()].full;
	return `${month} ${date.getDate()}, ${date.getFullYear()}`;
}

export function getDateTimeString(date) {
	if (!date || typeof date !== "object") {
		return null;
	}
	const month = months[date.getMonth()].full;
	let hours = date.getHours();
	let timeOfDay = "am";
	if (hours === 0) {
		hours += 12;
	} else if (hours === 12) {
		timeOfDay = "pm";
	} else if (hours > 12) {
		hours -= 12;
		timeOfDay = "pm";
	}
	let minutes = date.getMinutes().toString();
	if (minutes.length < 2) {
		minutes = `0${minutes}`;
	}

	return `${month} ${date.getDate()}, ${date.getFullYear()} at ${hours}:${minutes}${timeOfDay}`;
}

export function getShortDateString(date, delimeter) {
	if (!date || typeof date !== "object") {
		return null;
	}

	const delimit = delimeter === null || typeof delimeter === "undefined" ? "/" : delimeter;

	return `${date.getMonth() + 1}${delimit}${date.getDate()}${delimit}${date
		.getFullYear()
		.toString()
		.substr(2, 2)}`;
}

export function getShortApiDateString(date) {
	if (!date || typeof date !== "object") {
		return null;
	}

	let month = (date.getMonth() + 1).toString();
	if (month.length === 1) {
		month = `0${month}`;
	}

	let day = date.getDate().toString();
	if (day.length === 1) {
		day = `0${day}`;
	}

	return `${date.getFullYear().toString()}-${month}-${day}`;
}

export function parseApiDate(str) {
	if (!str || str.length !== "2020-05-12".length) {
		return null;
	}

	const [year, month, day] = str.split("-");

	const monthNum = parseInt(month, 10);
	const yearNum = parseInt(year, 10);
	const dayNum = parseInt(day, 10);

	return Number.isFinite(monthNum) && Number.isFinite(yearNum) && Number.isFinite(dayNum)
		? new Date(yearNum, monthNum - 1, dayNum)
		: null;
}

export function getShortUTCDateString(date) {
	if (!date || typeof date !== "object") {
		return null;
	}

	let month = (date.getUTCMonth() + 1).toString();
	if (month.length === 1) {
		month = `0${month}`;
	}

	let day = date.getUTCDate().toString();
	if (day.length === 1) {
		day = `0${day}`;
	}

	return `${date.getUTCFullYear().toString()}-${month}-${day}`;
}

export function getLongUTCDateString(date) {
	if (!date || typeof date !== "object") {
		return null;
	}

	const month = months[date.getUTCMonth()].full;
	const day = date.getUTCDate();

	return `${month} ${day}, ${date.getUTCFullYear().toString()}`;
}

export function isValidDateRange(before, after) {
	if (!before || !after) {
		return true;
	}

	const isoBefore = parseISO(before);
	const isoAfter = parseISO(after);

	return isBefore(isoAfter, isoBefore);
}

export function daysInMonth(month, year) {
	return new Date(year, month + 1, 0).getDate();
}

export function startDateEndDateToAPIStrings(obj) {
	const final = { ...obj };
	if (obj.start_date && typeof obj.start_date === "object") {
		final.start_date = getShortApiDateString(obj.start_date);
	}
	if (obj.end_date && typeof obj.end_date === "object") {
		final.end_date = getShortApiDateString(obj.end_date);
	}
	return final;
}
